import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import MarkAsPaidInstalmentForm from './MarkAsPaidInstalmentForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class MarkAsPaidInstalmentDialog extends Component {
    constructor(props) {
        super(props);  
    }


    dialogConfig() {
        const { t, onCancel } = this.props;

        return {
            header: t('PaymentHistory_MarkInstalmentAsPaid'),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm } = this.props;
        return <MarkAsPaidInstalmentForm onSubmit={onConfirm} />;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='markAsPaidInstalment' label={t('PaymentHistory_MarkAsPaid')} />;
        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

MarkAsPaidInstalmentDialog.propTypes = {
    show: PropTypes.bool,   
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(MarkAsPaidInstalmentDialog);